/* eslint-disable unused-imports/no-unused-vars */
import { API } from "../api";
import {
  THREEPL_URL,
  CITIES_URL,
  UNMAPPED_CITY
} from "../constants/url.constant";

export const REQUEST_CHARGES_DATA = "REQUEST_CHARGES_DATA";
export const GET_3PLS = "GET_3PLS";
export const ADD_3PL = "ADD_3PL";
export const GET_CHARGES = "GET_CHARGES";
export const REMOVE_MAP_CITY = "REMOVE_MAP_CITY";
export const DELETE_3PL = "DELETE_3PL";
export const UPDATE_3PL = "UPDATE_3PL";
export const GET_MAPPED_CITIES = "GET_MAPPED_CITIES";

export const get3PLS = (params = {}) => {
  return async (dispatch) => {
    const res = await API.get(THREEPL_URL, {
      params: params
    });
    dispatch({
      type: GET_3PLS,
      payload: res
    });
    return res;
  };
};

export const getMappedCities = (tplId, params) => {
  return async (dispatch) => {
    const res = await API.get(`${THREEPL_URL}/${tplId}/cities`, { params });
    dispatch({
      type: GET_MAPPED_CITIES,
      payload: res
    });
    return res;
  };
};

export const getCharges = (tplId, params) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_CHARGES_DATA });
    const res = await API.get(`${THREEPL_URL}/${tplId}/charges`, { params });
    dispatch({
      type: GET_CHARGES,
      payload: res
    });
    return res;
  };
};

export const addMapCity = (tplId, data) => {
  return async (dispatch) => {
    return await API.post(`${THREEPL_URL}/${tplId}/cities`, data);
  };
};

export const removeMappedCity = (tplId, cityCode) => {
  return async (dispatch) => {
    const res = await API.delete(
      `${THREEPL_URL}/${tplId}/cities/${cityCode}`
    );
    dispatch({
      type: REMOVE_MAP_CITY,
      payload: cityCode
    });
    return res;
  };
};

export const getUnMappedCities = () => {
  return async (dispatch) => {
    return await API.get(`${CITIES_URL}/${UNMAPPED_CITY}`);
  };
};

export const add3PL = (data) => {
  return async (dispatch) => {
    const res = await API.post(THREEPL_URL, data);
    dispatch({
      type: ADD_3PL,
      payload: data
    });
    return res;
  };
};

export const update3PL = (id, body) => {
  return async (dispatch) => {
    await API.put(`${THREEPL_URL}/${id}`, body);
    dispatch({ type: UPDATE_3PL, payload: { id, ...body } });
  };
};

export const remove3PL = (hubCode) => {
  return async (dispatch) => {
    const res = await API.delete(`${THREEPL_URL}/${hubCode}`);
    dispatch({
      type: DELETE_3PL,
      payload: hubCode
    });
    return res;
  };
};

export default function reducer(
  state = { table3PLRows: [], mappedCitiesRows: [], totalRows: 0, isChargesLoading: false },
  { type, payload }
) {
  switch (type) {
    case REQUEST_CHARGES_DATA:
      return {
        ...state,
        isChargesLoading: true
      };
    case GET_3PLS:
      return {
        ...state,
        table3PLColumns: payload.columns,
        table3PLRows: payload.rows,
        totalRows: payload.count
      };
    case GET_MAPPED_CITIES:
      return {
        ...state,
        mappedCitiesColumns: payload.columns,
        mappedCitiesRows: payload.rows,
        mappedCitiestotalRows: payload.count
      };
    case GET_CHARGES:
      return {
        ...state,
        chargesColumns: payload.columns,
        chargesRows: payload.rows,
        chargesTotalRows: payload.count
      };
    case REMOVE_MAP_CITY:
      return {
        ...state,
        mappedCitiesRows: state.mappedCitiesRows.filter(
          (city) => city.code !== payload
        )
      };
    case ADD_3PL:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        table3PLRows: [...state.table3PLRows, { ...payload }]
      };
    case DELETE_3PL:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        table3PLRows: state.table3PLRows.filter((pl) => pl.id !== payload)
      };
    case UPDATE_3PL:
      return {
        ...state,
        table3PLRows: state.table3PLRows.map((pl) =>
          pl.id === payload.code ? { ...payload } : pl
        )
      };
    default:
      return state;
  }
}
